module.exports = __webpack_public_path__ + "static/media/users-icon.6e03e9aa.svg";